var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LinkA',{staticClass:"link-button",attrs:{"bgcolor":_vm.Color,"href":_vm.Link,"target":"_blank"}},[_c('span',[_vm._v("🔗")])])}
var staticRenderFns = []

export { render, staticRenderFns }